import styles from './SliderBlock.module.scss'
import imageGalleryObject from '@/entities/imageGallery/interface'
import GallerySlider from '@/components/models/media/GallerySlider'

interface Props {
  gallery: imageGalleryObject
  autoplay: boolean
  showLightbox: boolean
  showDots: boolean
  showArrows: boolean
  size: 'default' | 'small'
}

const SliderBlock = ({ gallery, showDots, showArrows, showLightbox, autoplay, size }: Props) => {
  return (
    <div className={styles.root}>
      <GallerySlider
        gallery={gallery}
        sliderDotsPosition={!showDots ? 'off' : undefined}
        showArrows={showArrows}
        showLightbox={showLightbox}
        autoplay={autoplay}
        trackingStringPrefix={'cms_block:slider'}
        size={size}
      />
    </div>
  )
}

export default SliderBlock
